export { default } from './pharmaprix-pharmacy-disclaimer.component';
